import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IStudentLecturesProgressVm } from '../student-lectures-progress-vm.model';

@Injectable({ providedIn: 'root' })
export class MyOskStudentLecturesService {
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {}

  getAll(studentGuid: string): Observable<IStudentLecturesProgressVm[]> {
    return this.http.get<IStudentLecturesProgressVm[]>(
      this.apiUrl + '/MyOskStudentLectures',
      { params: { studentGuid }, headers: this.headers() }
    );
  }

  private headers(): HttpHeaders {
    const token = localStorage.getItem('authToken');
    return token
      ? new HttpHeaders({ Authorization: 'Bearer ' + token })
      : new HttpHeaders();
  }
}

